import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompMeta from '../../meta/LowCodeComponents/Label';
/**
 * @class NCLabel
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCLabel
 * @label 文本
 *
 */
class NCLabel extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title title
         * @description title
         */
        title: PropTypes.string,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <label {...this.props} style={{ minWidth: '30px', minHeight: '30px' }}>{this.props.title || "label"}</label>
        )
    }
}

export default NCLabel;
